import { LabWorkbookStatus } from '@resistapp/common/types';

import { isStatusAtLeast } from './status-utils';

export type LabStepIconVariant = 'none' | 'first' | 'both';

type SmartChipRunFileDescriptor = {
  filename: string;
  url: string;
};

type SmartChipRunChipFiles = {
  cts: SmartChipRunFileDescriptor | null;
  raw: SmartChipRunFileDescriptor | null;
};

type SmartChipRunChip = {
  files: SmartChipRunChipFiles;
};

export function getSmartChipRunIconVariant(options: {
  chips: SmartChipRunChip[] | null | undefined;
  expectedChipCount: number | null | undefined;
}): LabStepIconVariant {
  const chips = options.chips ?? [];

  const hasAnyUploads = chips.some(chip => Boolean(chip.files.raw) || Boolean(chip.files.cts));
  if (!hasAnyUploads) {
    return 'none';
  }

  const expected = options.expectedChipCount ?? 0;
  const analysed = chips.filter(chip => Boolean(chip.files.cts)).length;
  if (expected > 0 && analysed >= expected) {
    return 'both';
  }
  return 'first';
}

export function isSampleSpecDoubleIcon(options: {
  submitted: number | null | undefined;
  minimumRequired: number | null | undefined;
}): boolean {
  const submitted = options.submitted ?? 0;
  const minimumRequired = options.minimumRequired ?? null;
  return minimumRequired != null && submitted >= minimumRequired;
}

export function getSampleSpecIconVariant(options: {
  status: LabWorkbookStatus | null | undefined;
  submitted: number | null | undefined;
  minimumRequired: number | null | undefined;
}): LabStepIconVariant {
  if (!isStatusAtLeast(options.status, LabWorkbookStatus.SUBMITTED)) {
    return 'none';
  }

  return isSampleSpecDoubleIcon(options) ? 'both' : 'first';
}

export function getDnaQaIconVariant(options: {
  status: LabWorkbookStatus | null | undefined;
  hasMeasurements: boolean | null | undefined;
  submitted: number | null | undefined;
  minimumRequired: number | null | undefined;
}): LabStepIconVariant {
  const sampleSpecIsDouble = isSampleSpecDoubleIcon(options);
  if (isStatusAtLeast(options.status, LabWorkbookStatus.MEASURED) && sampleSpecIsDouble) {
    return 'both';
  }

  if (Boolean(options.hasMeasurements) || isStatusAtLeast(options.status, LabWorkbookStatus.MEASURED)) {
    return 'first';
  }

  return 'none';
}
